import React, { Component } from 'react';
import ProductComp from '../../../../components/reports/inventory/product';

export default class Product extends Component {
	render() {
		return <ProductComp />;
	}
}
